import { Component, Input, ViewChild } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"
import { FacebookShareComponent } from "../../social/facebook/facebook-share.component"
import { TwitterShareComponent } from "../../social/twitter/twitter-share.component"
import { PinterestShareComponent } from "../../social/pinterest/pinterest-share.component"
import Utils from "../../../utils/utils"
import { NotificationsService } from "angular2-notifications"

@Component({
    selector: "app-social-share-modal",
    templateUrl: "./social-share-modal.component.html",
    styleUrls: ["./social-share-modal.component.scss"],
    standalone: false,
})
export class SocialShareModalComponent {
    @Input() titleToShare: string = ""

    @ViewChild(FacebookShareComponent)
    private facebook: FacebookShareComponent

    @ViewChild(TwitterShareComponent)
    private twitter: TwitterShareComponent

    @ViewChild(PinterestShareComponent)
    private pinterest: PinterestShareComponent

    constructor(
        public activeModal: ModalRef,
        private notificationService: NotificationsService
    ) {}

    public facebookShare() {
        this.facebook.share()
    }

    public twitterShare() {
        this.twitter.share()
    }

    public pinterestShare() {
        this.pinterest.share()
    }

    public reminder(event) {
        event.preventDefault()
        const remindText = encodeURIComponent('"' + this.titleToShare + '" on PBS LearningMedia')
        const composedUrl =
            "https://www.remind.com/v1/share?url=" +
            window.location.origin +
            window.location.pathname +
            "&referrer=" +
            window.location.origin +
            window.location.pathname +
            "&text=" +
            remindText
        window.open(composedUrl, null, "width=1024, height=600,toolbar=no, scrollbars=yes")
    }

    public emailShare() {
        const currentUrl = window.location.href
        Utils.copyTextToClipboard(currentUrl)
        this.notificationService.success(
            "Url copied",
            "The current resource URL was copied to the clipboard",
            Utils.alertConfiguration
        )
        window.location.href = `mailto:?subject=PBS LearningMedia: ${this.titleToShare}&body=From PBS LearningMedia:%0A${this.titleToShare}%0A${currentUrl}`
    }
}
